import type { IEditorPreloader } from '@confluence/edit-button/entry-points/types.ts';

export const nativeEditorComponentsPreloader = async (): Promise<void> => {
	return (
		await import(
			/* webpackChunkName: "loadable-nativeEditorComponentsPreloader" */
			'./nativeEditorComponentsPreloader.ts'
		)
	).nativeEditorComponentsPreloader();
};

export const tinyEditorComponentsPreloader = async (): Promise<void> => {
	return (
		await import(
			/* webpackChunkName: "loadable-tinyEditorComponentsPreloader" */
			'./tinyEditorComponentsPreloader.ts'
		)
	).tinyEditorComponentsPreloader();
};

export const getEditorPreloader = async (): Promise<
	() => (config: IEditorPreloader) => JSX.Element
> => {
	return (
		await import(
			/* webpackChunkName: "loadable-getEditorPreloader" */
			'../editorPreloader.tsx'
		)
	).getEditorPreloader;
};
